const StripeActionTypes = {
  SET_STRIPE_CLIENT: "SET_STRIPE_CLIENT"
};

export default StripeActionTypes;
